import React from "react";
import PhoneAuth from "../../userData/phoneAuth/PhoneAuth";
import { PhoneAuthProps } from "../../userData/phoneAuth/PhoneAuth";

const PhoneAuthStep: React.FC<PhoneAuthProps> = (props) => {
  return <PhoneAuth verifiedPhone={props.verifiedPhone} />;
};

export default PhoneAuthStep;
